export default function QuoteLifecycleBadges({ lifecycle, testId }) {
  const badges = lifecycle?.badges || [];
  if (!badges.length) return null;
  return (
    <div className="quote-badge-row" data-testid={testId}>
      {badges.map((b) => (
        <span key={b.id} className={`quote-badge quote-badge--${b.tone || "neutral"}`}>
          {b.label}
        </span>
      ))}
    </div>
  );
}
